import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Replaces @angular/fire's AuthGuard. Awaits session restoration, then allows
 * the route when a valid Supabase session exists; otherwise redirects to login.
 */
export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const token = await authService.getValidToken();
  return token ? true : router.parseUrl('/login');
};
